// Platform error codes surfaced by the contact method mutations.
export const CONTACT_METHOD_ERROR = {
  NO_ACCESS: 'E010',
  PHONE_TAKEN: 'E057',
  MARKETING_PHONE: 'E503',
  EMAIL_TAKEN: 'E505',
};

// Email changes batch into a single mutation, so their errors are keyed to the
// section rather than to an individual row.
export const EMAIL_ERROR_KEY = 'emails';

// Shown once for the whole form rather than against an individual row, so it
// speaks about the set of methods rather than about one of them.
export const CONTACT_METHOD_LOCKED_COPY =
  'Some contact methods have been authenticated by the owner. Please contact ' +
  'support@waldophotos.com to request a change or add another contact ' +
  'method below.';
